import { ICalaendarType } from '../features/calendar/calendar-slice';
import { api } from './api.service';

export interface INeed {
  id: string;
  name: string;
  route: string;
  products: [];
  disable: boolean;
}
export interface INeedsResult {
  need: INeed[];
  supportChatEnabled: boolean;
}

export interface IdNeed {
  serviceId?: string;
}

export interface INeedResult {
  id: string;
  name: string;
  products: [
    {
      durationTime: number | null;
      calendars: [
        {
          durationEvent: number;
        }
      ];
      calendarTypes: Array<ICalaendarType>;
      id: string;
      name: string;
      price: number;
      services: string;
      insurance?: string[];
      tags: null;
      alias: null;
      reimbursementValue: number;
      nextStepsAfterPayment: string;
      shortDescription: string;
      emailTemplatePayment: string;
      active: boolean;
      sort: number;
      primaryColor: string;
      imageHeaderCard: string;
      linkBeforeSchedule: string;
      urlAnamnese: string;
      invoiceDescription: string;
      template: string;
      omieProductCode: string;
      omieProductCategory: string;
      omieIntegrationActive: boolean;
      sendAnamnese: boolean;
      isNeedAddress: boolean;
      maxInstallment: number;
      isAdditionalProduct: boolean;
      isProceedure: boolean;
    }
  ];
}

export const needs = api.injectEndpoints({
  endpoints: build => ({
    getNeeds: build.mutation<INeedsResult, any>({
      query: () => ({
        url: `/needs/schedule`
      })
    }),
    getNeed: build.mutation<INeedResult, IdNeed>({
      query: ({ serviceId }) => ({
        url: `/needs/${serviceId}`
      })
    })
  })
});

export const { useGetNeedMutation, useGetNeedsMutation } = needs;
